import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/Button/index.js